import { render, staticRenderFns } from "./SignatureFont.vue?vue&type=template&id=2e65681a&"
import script from "./SignatureFont.vue?vue&type=script&lang=js&"
export * from "./SignatureFont.vue?vue&type=script&lang=js&"
import style0 from "./SignatureFont.vue?vue&type=style&index=0&id=2e65681a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports